<template>
  <div
    v-if="showSearch || modelValue"
    :class="inputClass"
  >
    <q-input
      :model-value="modelValue"
      :debounce="debounce"
      autofocus
      outlined
      dense
      hide-bottom-space
      data-e2e="input-search-table"
      class="search"
      :label="$t('library.searchLabel')"
      @update:model-value="onInput"
      @blur="onBlur"
    >
      <template #append>
        <q-icon
          name="clear"
          class="cursor-pointer"
          data-e2e="button-close-search"
          @click="onHideSearch"
        />
      </template>
    </q-input>
  </div>
  <div
    v-else
  >
    <q-btn
      round
      flat
      dense
      color="primary"
      icon="search"
      data-e2e="button-search-table"
      :class="btnClass"
      @click="onShowSearch"
    />
  </div>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
  name: 'SearchInput',

  props: {
    modelValue: {
      type: String,
      required: true,
    },

    inputClass: {
      type: [String, Object],
      default: null,
    },

    btnClass: {
      type: Object,
      default: null,
    },

    debounce: {
      type: [Number, String],
      default: 300,
    },
  },

  emits: ['show-input', 'update:modelValue', 'hide-input', 'blur-input'],

  data() {
    return {
      showSearch: false,
    };
  },

  methods: {
    onShowSearch() {
      this.showSearch = true;
      this.$emit('show-input');
    }, // onShowSearch()

    onHideSearch() {
      this.showSearch = false;
      this.$emit('update:modelValue', '');
      this.$emit('hide-input');
    }, // onHideSearch()

    onInput(val) {
      this.$emit('update:modelValue', val);
    }, // onInput()

    onBlur() {
      if (isEmpty(this.modelValue)) {
        this.showSearch = false;
        this.$emit('blur-input');
      }
    }, // onBlur()
  },
};
</script>

<style scoped>
  .search {
    height: 36px;
  }
</style>
